import _ from "underscore";
import { MobileActions } from "../../store/mobile/actions";
import { getCurrentVehicle } from "../../utils/device";
import * as logger from "../../utils/logger";
import pageHTML from "./webSocketDebug.tmpl";
import DebugPageView from "./debugPageView";

export default class WebSocketDebugView extends DebugPageView {
    private readonly template = _.template(pageHTML);
    private updateInterval: any = null;

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #increaseIgnoreCount": this.increaseIgnoreCount,
            "click #decreaseIgnoreCount": this.decreaseIgnoreCount,
            "click #resetIgnoreCount": this.resetIgnoreCount,
            "click #resetIgnoredMessages": this.resetIgnoredMessages,
            "click #sendManualAck": this.sendManualAck
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render() {
        const channel = this.app.context.webSocketChannel;
        const currentVehicle = getCurrentVehicle(this.app.store);
        const deviceId = currentVehicle?.id ?? "";

        this.el.innerHTML = this.template({
            ignoreAckCount: channel?.getIgnoreAckCount() ?? 0,
            ignoredMessagesCount: channel?.getIgnoredMessagesCount() ?? 0,
            isConnected: channel?.isInitialized() ?? false,
            deviceId: deviceId
        });

        this.app.store.dispatch(MobileActions.setPageState({
            title: "WebSocket Debug",
            pageLevel: 2
        }));

        // Update counters every 500ms to show real-time changes
        this.startAutoUpdate();

        return this;
    }

    remove() {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
        return super.remove();
    }

    increaseIgnoreCount() {
        const channel = this.app.context.webSocketChannel;
        if (channel) {
            channel.setIgnoreAckCount(channel.getIgnoreAckCount() + 1);
            this.updateCounters();
        }
    }

    decreaseIgnoreCount() {
        const channel = this.app.context.webSocketChannel;
        if (channel) {
            const current = channel.getIgnoreAckCount();
            if (current > 0) {
                channel.setIgnoreAckCount(current - 1);
                this.updateCounters();
            }
        }
    }

    resetIgnoreCount() {
        const channel = this.app.context.webSocketChannel;
        if (channel) {
            channel.setIgnoreAckCount(0);
            this.updateCounters();
        }
    }

    resetIgnoredMessages() {
        const channel = this.app.context.webSocketChannel;
        if (channel) {
            channel.resetIgnoredMessagesCount();
            this.updateCounters();
        }
    }

    sendManualAck() {
        const deviceIdInput = <HTMLInputElement>document.getElementById("manualDeviceId");
        const deviceId = deviceIdInput?.value?.trim();

        if (deviceId) {
            const channel = this.app.context.webSocketChannel;
            if (channel) {
                channel.sendManualAck(deviceId);
                logger.log(logger.Source.DEBUG, `Manually sent ACK for device: ${ deviceId }`);
            }
        }
    }

    private startAutoUpdate() {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
        }

        this.updateInterval = setInterval(() => {
            this.updateCounters();
        }, 500);
    }

    private updateCounters() {
        const channel = this.app.context.webSocketChannel;
        if (channel) {
            const ignoredMessagesElement = document.querySelector("#ignoredMessagesCount");
            if (ignoredMessagesElement) {
                ignoredMessagesElement.textContent = channel.getIgnoredMessagesCount().toString();
            }
            const ignoreCountElement = document.querySelector("#currentIgnoreCount");
            if (ignoreCountElement) {
                ignoreCountElement.textContent = channel.getIgnoreAckCount().toString();
            }
        }
    }
}
